import React, {Component} from 'react';
import bankTheme from '../theme/bankTheme';
import MainPage from '../containers/MainPage'



class ThemeMainPage extends Component {
  render() {
    return (
     <div  >
      <MainPage history = {this.props.history} secureToken = {this.props.location.state.secureToken} customTheme='yes'/>
    </div>
    );
  }
}

export default bankTheme((ThemeMainPage));